import CeramicTiles from "./steps/CeramicTiles";
import Floors from "./steps/Floors";
import WallPaints from "./steps/WallPaints";
import Electricity from "./steps/Electricity";
import SanitaryEquipment from "./steps/SanitaryEquipment";
import Extras from "./steps/Extras";
import Summary from "./steps/Summary";

export const components = {
    CeramicTiles,
    Floors,
    WallPaints,
    Electricity,
    SanitaryEquipment,
    Extras,
    Summary,
};

const unpreparedSteps = [
    {
        component: "CeramicTiles",
        title: "Ceramic Tiles",
    },
    {
        component: "Floors",
        title: "Floors",
    },
    {
        component: "WallPaints",
        title: "Wall Paints",
    },
    {
        component: "Electricity",
        title: "Electricity",
    },
    {
        component: "SanitaryEquipment",
        title: "Sanitary Equipment",
    },
    {
        component: "Extras",
        title: "Extras",
    },
    {
        component: "Summary",
        title: "Summary",
    },
];

/**
 * Before exporting steps add index, previousStep and nextStep
 * field for each step.
 *
 */
const preparedSteps = [];
let previousStep = null;
let nextStep;
unpreparedSteps.forEach((e, i) => {
    nextStep = e.nextStep ? e.nextStep : null;
    if (!nextStep && i + 1 < unpreparedSteps.length && unpreparedSteps[i + 1]) {
        nextStep = unpreparedSteps[i + 1].component;
    }
    preparedSteps.push({
        index: i,
        previousStep,
        nextStep,
        ...e,
    });
    previousStep = e.component;
});

export const steps = preparedSteps;
